module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_FISICA_1_B-8e907bc8fca70e168f876382b62f8622.gif";